module.exports = __webpack_public_path__ + "08cc5651085eda1a85db6086dd81a72c.jpg";